import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { SmoMoonList } from '../../../../../Models/Smo/SmoMoonList';
import UserStoreActions from '../../../../../Modules/Redux/Global/User/UserStoreActions';
import UserStoreSelector from '../../../../../Modules/Redux/Global/User/UserStoreSelector';
import { useShowSidebar } from '../../../../../Utils/Hooks/UseShowSidebar';
import { SidebarItem } from '../../SidebarItem/SidebarItem';
import { SidebarSection } from '../../SidebarSection/SidebarSection';
import { SidebarMoonListItemContent } from '../Components/SidebarMoonItemContent/SidebarMoonListItemContent';

export const SidebarMoonListSection: FunctionComponent = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const showSidebar = useShowSidebar();
  const dispatch = useDispatch();
  const createdMoonLists: SmoMoonList[] = useSelector(UserStoreSelector.createdMoonLists);

  useEffect(() => {
    if (showSidebar) {
      dispatch(UserStoreActions.getCurrentUserMoonLists());
    }
  }, [showSidebar]);

  function goToMoonListWithId(moonListId: string): void {
    navigate(`/moon/list/${moonListId}`);
  }

  function isItemSelected(moonListId: string): boolean {
    return pathname === `/moon/list/${moonListId}`;
  }

  return (
    <SidebarSection title="Your moon lists">
      {createdMoonLists.map((moonList) => (
        <SidebarItem
          key={moonList.id}
          isSelected={isItemSelected(moonList.id)}
          icon="/images/icons/moon_red.svg"
          selectedIcon="/images/icons/moon_white.svg"
          onClick={(): void => goToMoonListWithId(moonList.id)}
        >
          <SidebarMoonListItemContent moonList={moonList} isSelected={isItemSelected(moonList.id)} />
        </SidebarItem>
      ))}
    </SidebarSection>
  );
};
